import { Component } from '@angular/core';

@Component({
    selector: 'ah-error',
    templateUrl: './error.component.html',
    styleUrls: [`./../four0four/four0four.component.scss`],
    standalone: false
})
export class ErrorComponent { }
